export var logoPortalTokens = {
  defaultVariant: "default",
  variants: {
    default: {
      color: function color(_ref) {
        var palette = _ref.palette;
        return palette.baseBlue.hex50;
      }
    },
    modern: {
      color: function color(_ref2) {
        var palette = _ref2.palette;
        return palette.newBlue.hex50;
      }
    }
  }
};